import { createFileRoute, notFound } from "@tanstack/react-router";
import { normalizeOnboardingV1StepSearch } from "~/features/start";

const ONBOARDING_V1_PREVIEW_DESCRIPTION =
  "Development-only preview for the next Glider onboarding flow.";
const ONBOARDING_V1_PREVIEW_TITLE = "Onboarding V1 Preview | Glider";

export const Route = createFileRoute("/onboarding-v1-preview")({
  beforeLoad: () => {
    if (!(import.meta.env.DEV || import.meta.env.MODE === "test")) {
      throw notFound();
    }
  },
  head: () => ({
    meta: [
      { title: ONBOARDING_V1_PREVIEW_TITLE },
      { content: ONBOARDING_V1_PREVIEW_DESCRIPTION, name: "description" },
      { content: "noindex, nofollow", name: "robots" },
    ],
  }),
  validateSearch: normalizeOnboardingV1StepSearch,
});
